import { useState, useEffect } from 'react';
import './Contact.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../image/logo.png'; // Make sure to have your logo in this path

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch('https://koru-ai-eight.vercel.app/contact' || 'https://koru-ai.onrender.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

      toast.success("✨ Your message has been sent successfully!");
    } catch (error) {
      console.error('Error:', error);
      toast.error('❌ Failed to send message. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page-new">
      <div className="contact-wrapper">
        {/* Left Side - Contact Form */}
        <div className="contact-form-section">
          <div className="form-header">
            <h1>Contact Us</h1>
            <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
          </div>

          <form onSubmit={handleSubmit} className="contact-form-new">
            <div className="form-row">
              <div className="form-field">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-field">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div className="form-field full-width">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="What's this about?"
              />
            </div>

            <div className="form-field full-width">
              <label>Your Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Tell us how we can help you..."
              ></textarea>
            </div>

            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Sending...
                </>
              ) : (
                <>
                  Send Message <span className="arrow">→</span>
                </>
              )}
            </button>
          </form>
        </div>

        {/* Right Side - Brand Info */}
        <div className="brand-section">
          <div className="brand-content">
            <div className="brand-logo">
              <div className="logo-icon">
                <img
                  src={logo}  // Replace with your actual logo path
                  alt="Koru AI Logo"
                  className="brand-logo-img"
                />
              </div>
              <h2>Koru AI</h2>
            </div>

            <p className="brand-tagline">
              Discover the future of AI tools with Koru AI - Your ultimate directory for artificial intelligence solutions.
            </p>

            <div className="brand-stats">
              <div className="stat">
                <span className="stat-number">16K+</span>
                <span className="stat-label">AI Tools</span>
              </div>
              <div className="stat">
                <span className="stat-number">13+</span>
                <span className="stat-label">Categories</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support</span>
              </div>
            </div>

            <div className="connect-section">
              <h3>Connect with us</h3>
              <div className="social-icons-new">
                <a href="https://www.instagram.com/rajputaman625" target="_blank" rel="noopener noreferrer" className="social-icon insta">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/in/aman-rajput-2b7680316/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                  <i className="bi bi-linkedin"></i>
                </a>
                <a href="https://github.com/rajput81325" target="_blank" rel="noopener noreferrer" className="social-icon github">
                  <i className="bi bi-github"></i>
                </a>
              </div>
            </div>

            <div className="contact-email">
              <i className="bi bi-envelope-fill"></i>
              <span>c84289798@gmail.com</span>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="decorative-elements">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        theme="light"
      />
    </div>
  );
}

export default Contact;